import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_ACCESS } from '@/modules/Core/constants/adminAccess'

const DiscountRoutes: RouteRecordRaw = {
  path: '/discount',
  name: 'DiscountModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManageDiscountRoute',
      component: () => import('./views/ManageDiscountView.vue'),
      meta: {
        title: 'تخفیفات',
      },
    },
  ],
  meta: {
    layout: 'Default',
    allowedRoles: MODULE_ACCESS.discount,
  },
}

export default (router: Router) => {
  router.addRoute(DiscountRoutes)
}
